import { render, staticRenderFns } from "./Spec.vue?vue&type=template&id=4a9ce5ca&scoped=true"
import script from "./Spec.vue?vue&type=script&lang=js"
export * from "./Spec.vue?vue&type=script&lang=js"
import style0 from "./Spec.vue?vue&type=style&index=0&id=4a9ce5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ce5ca",
  null
  
)

export default component.exports